<!-- PersonalProfileForm.vue -->
<template>
  <v-card outlined class="pa-6">

    <!-- Skeleton Loader -->
    <v-skeleton-loader
      v-if="loading"
      type="card, list-item, text"
      class="mb-4"
      boilerplate
      elevation="0"
      max-width="800"
    />
    
    <h3 class="text-h6 font-weight-bold mb-4">Personal profile</h3>
    <v-form ref="formRef" @submit.prevent="onSubmit">
      <v-row dense>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="form.contact_name"
            label="Contact Name*"
            variant="outlined"
            dense
            :rules="[rules.required]"
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="form.communication_email"
            label="Communication Email"
            variant="outlined"
            dense
            :rules="[rules.email]"
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="form.phone_number"
            label="Phone Number*"
            variant="outlined"
            dense
            :rules="[rules.required]"
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-select
            v-model="form.city_id"
            :items="cities"
            label="City*"
            item-text="name"
            item-value="id"
            variant="outlined"
            dense
            :rules="[rules.required]"
          />
        </v-col>
      </v-row>

      <div class="text-right mt-4">
        <v-btn type="submit" color="red darken-1" dark>Save</v-btn>
      </div>
    </v-form>
  </v-card>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { useStore } from "vuex";
const loading = ref(true);


const props = defineProps({
  cities: {
    type: Array,
    required: true,
  },
});
const emit = defineEmits(["save"]);
const store = useStore();

const formRef = ref(null);
const form = reactive({
  id: null,
  contact_name: "",
  communication_email: "",
  phone_number: "",
  city_id: null,
});

const rules = {
  required: (v) => !!v || "This field is required",
  email: (v) =>
    !v ||
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ||
    "Must be a valid email address",
};



onMounted(async () => {
  try {
    const profile = store.getters["personalProfile/profile"];
     console.log("Whats inside personal profile", profile);
    if (profile) {
      form.id = profile.id;
      form.contact_name = profile.contact_name;
      form.communication_email = profile.communication_email;
      form.phone_number = profile.phone_number;
      form.city_id = profile.city_id;
    }
  } catch (e) {
    console.error("Failed to load profile:", e);
  } finally {
    loading.value = false;
  }
});

async function onSubmit() {
  if (!(await formRef.value.validate())) return;
  emit("save", { ...form });
}
</script>
